/* Japan Centre – Chosen Day picker for chilled & frozen orders (required) and other
   orders (optional, "choose a delivery date").
   Markup and the date rules (data-*) come from snippets/jc-chosen-day-picker.liquid.
   Loaded on every page from layout/theme.liquid, because the cart drawer is re-rendered
   with AJAX and scripts inside it would not run. */
(function () {
  if (window.JCChosenDay) return;

  var DAY_EN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAY_JA = ['日', '月', '火', '水', '木', '金', '土'];

  // Today's date and hour in the UK, whatever the customer's own time zone is.
  function ukNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)), hour: +parts.hour };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }

  // England & Wales bank holidays from gov.uk, so new years appear without a theme change.
  // The list in the snippet (data-closed) stays as a fallback if gov.uk cannot be reached.
  var bankHolidays = null;
  function loadBankHolidays() {
    if (bankHolidays) return bankHolidays;
    bankHolidays = new Promise(function (resolve) {
      try {
        var cached = sessionStorage.getItem('jc-cdp-bank-holidays');
        if (cached) { resolve(JSON.parse(cached)); return; }
      } catch (e) {}
      var timer = setTimeout(function () { resolve([]); }, 4000);
      fetch('https://www.gov.uk/bank-holidays.json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          clearTimeout(timer);
          var list = data['england-and-wales'].events.map(function (e) { return e.date; });
          try { sessionStorage.setItem('jc-cdp-bank-holidays', JSON.stringify(list)); } catch (e) {}
          resolve(list);
        })
        .catch(function () { clearTimeout(timer); resolve([]); });
    });
    return bankHolidays;
  }

  // now: optional { date: Date (UTC midnight of the UK day), hour } for testing.
  // extraClosed: optional list of YYYY-MM-DD (bank holidays from gov.uk).
  function dates(el, now, extraClosed) {
    var closed = (el.dataset.closed || '').split(',').concat(extraClosed || []);
    // Every year, e.g. "12-25..12-30,01-01..01-06".
    var yearly = (el.dataset.closedYearly || '').split(',').filter(Boolean).map(function (r) {
      var p = r.split('..');
      return { from: p[0], to: p[1] || p[0] };
    });
    var isClosed = function (d) {
      var day = iso(d), md = day.slice(5);
      if (closed.indexOf(day) !== -1) return true;
      return yearly.some(function (r) { return md >= r.from && md <= r.to; });
    };
    var days = el.dataset.days.split(',').map(Number);
    var isWorking = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !isClosed(d); };
    now = now || ukNow();

    // The order counts from today only if it is a working day and before the cut-off.
    var start = now.date;
    if (!(isWorking(start) && now.hour < +el.dataset.cutoff)) {
      do { start = addDays(start, 1); } while (!isWorking(start));
    }
    var d = start, left = +el.dataset.lead;
    while (left > 0) { d = addDays(d, 1); if (isWorking(d)) left--; }

    var out = [];
    for (var guard = 0; out.length < +el.dataset.options && guard < 120; guard++, d = addDays(d, 1)) {
      if (days.indexOf(d.getUTCDay()) !== -1 && !isClosed(d)) out.push(new Date(d.getTime()));
    }
    return out;
  }

  function label(d, lang) {
    if (lang === 'ja') return (d.getUTCMonth() + 1) + '月' + d.getUTCDate() + '日（' + DAY_JA[d.getUTCDay()] + '）';
    return DAY_EN[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MON_EN[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
  }
  // Stored value is always English + ISO date, so staff and apps read the same text in either language.
  function value(d) { return DAY_EN[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MON_EN[d.getUTCMonth()] + ' ' + d.getUTCFullYear() + ' (' + iso(d) + ')'; }

  function save(val) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ attributes: { 'Delivery date': val } })
    }).catch(function () {});
  }

  // Required for chilled & frozen; otherwise only once the customer ticks "choose a date".
  function isActive(el) {
    if (el.dataset.required === 'true') return true;
    var toggle = el.querySelector('[data-jc-cdp-toggle]');
    return !!(toggle && toggle.checked);
  }

  function syncOthers(select) {
    document.querySelectorAll('[data-jc-cdp] select').forEach(function (s) { if (s !== select) s.value = select.value; });
  }

  function setup(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var select = el.querySelector('select');
    var toggle = el.querySelector('[data-jc-cdp-toggle]');
    var fields = el.querySelector('.jc-cdp__fields');
    var lang = el.dataset.lang;
    var saved = el.dataset.saved;

    if (toggle) {
      toggle.checked = !!saved;
      fields.hidden = !toggle.checked;
      toggle.addEventListener('change', function () {
        fields.hidden = !toggle.checked;
        el.classList.remove('is-invalid');
        el.querySelector('.jc-cdp__error').hidden = true;
        if (!toggle.checked && select.value) {
          select.value = '';
          save('');
          syncOthers(select);
        }
        document.querySelectorAll('[data-jc-cdp] [data-jc-cdp-toggle]').forEach(function (t) {
          if (t !== toggle) { t.checked = toggle.checked; t.closest('[data-jc-cdp]').querySelector('.jc-cdp__fields').hidden = !toggle.checked; }
        });
      });
    }

    select.addEventListener('change', function () {
      el.classList.remove('is-invalid');
      el.querySelector('.jc-cdp__error').hidden = true;
      save(select.value);
      syncOthers(select);
    });

    loadBankHolidays().then(function (holidays) {
      var keep = false;
      dates(el, null, holidays).forEach(function (d) {
        var o = document.createElement('option');
        o.value = value(d); o.textContent = label(d, lang);
        if (o.value === saved) { o.selected = true; keep = true; }
        select.appendChild(o);
      });
      // A date saved earlier that is no longer deliverable (or not allowed for this basket) is dropped.
      if (saved && !keep) {
        save('');
        if (toggle) { toggle.checked = false; fields.hidden = true; }
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-jc-cdp]').forEach(setup);
    document.querySelectorAll('[data-jc-cdp-clear]').forEach(function (i) {
      if (!i.dataset.done) { i.dataset.done = '1'; save(''); }
    });
  }

  // Block checkout from the cart page or drawer until a date is chosen (when one is needed).
  function guard(evt, form) {
    var el = form && form.querySelector('[data-jc-cdp]');
    if (!el || !isActive(el) || el.querySelector('select').value) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    el.classList.add('is-invalid');
    el.querySelector('.jc-cdp__error').hidden = false;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.querySelector('select').focus();
  }
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[name="checkout"]');
    if (btn) guard(evt, btn.form || btn.closest('form'));
  }, true);
  document.addEventListener('submit', function (evt) {
    if (evt.submitter && evt.submitter.name === 'checkout') guard(evt, evt.target);
  }, true);

  // The drawer is re-rendered after quantity changes; set up the new copy.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; init(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.JCChosenDay = { init: init, dates: dates };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
